"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var numeral = require("numeral");
var React = require("react");
var Square = require("react-icons/lib/md/stop");
var react_redux_1 = require("react-redux");
var Button_1 = require("../component/Button");
var notification = require("../infra/notification");
var tasks_1 = require("../redux/tasks");
var timer_1 = require("../redux/timer");
require("./style/Timer.css");
var workSeconds = 25 * 60;
var restSeconds = 5 * 60;
var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    function Timer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { rest: false, seconds: workSeconds };
        _this.saveSpentTime = function () {
            var _a = _this.props, currentItem = _a.currentItem, updateCurrentItem = _a.updateCurrentItem;
            updateCurrentItem(__assign({}, currentItem, { spentSeconds: currentItem.spentSeconds + workSeconds - _this.state.seconds }));
        };
        return _this;
    }
    Timer.prototype.componentDidMount = function () {
        var _this = this;
        this.timer = setInterval(function () { return _this.setState({ seconds: Math.max(_this.state.seconds - 1, 0) }); }, 1000);
    };
    Timer.prototype.componentWillUnmount = function () {
        clearInterval(this.timer);
    };
    Timer.prototype.componentDidUpdate = function (_, _a) {
        var seconds = _a.seconds;
        if (seconds !== 0 && this.state.seconds === 0) {
            this.props.playAlarm();
            notification.notify(this.state.rest ? "Break finished." : "1 pomodoro finished.");
            if (!this.state.rest) {
                this.saveSpentTime();
                this.setState({ rest: true, seconds: restSeconds });
            }
        }
    };
    Timer.prototype.render = function () {
        var _this = this;
        var toggleTimer = this.props.toggleTimer;
        var _a = this.state, rest = _a.rest, seconds = _a.seconds;
        var postfix = rest ? "-rest" : "";
        return (React.createElement("div", { className: "Timer-container" + postfix },
            React.createElement("div", { className: "Timer-time" + postfix },
                React.createElement("div", { className: "Timer-minutes" }, Math.floor(seconds / 60)),
                React.createElement("div", { className: "Timer-seconds" }, numeral(seconds % 60).format("00"))),
            React.createElement(Button_1.default, { className: "Timer-button", onClick: function () {
                    if (!rest) {
                        _this.saveSpentTime();
                    }
                    toggleTimer();
                } },
                React.createElement(Square, null))));
    };
    return Timer;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var tasks = _a.tasks, timer = _a.timer;
    return (__assign({}, tasks, timer));
}, __assign({}, tasks_1.actionCreators, timer_1.actionCreators))(Timer);



//////////////////
// WEBPACK FOOTER
// ./src/container/Timer.tsx
// module id = 710
// module chunks = 0